import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { PICKING_TASKS_TO_BREAK } from '../../navigation/constants'

// Amber, not red: a partially pickable order is missing only units picking does not require,
// so it still gets assigned. Red is reserved for what the backend refuses.
export const PICKABILITY_STATUSES = [
  { status: 'FULLY_PICKABLE', classes: 'bg-green-100 text-green-800' },
  { status: 'PARTIALLY_PICKABLE', classes: 'bg-amber-100 text-amber-800' },
  { status: 'NOTHING_PICKABLE', classes: 'bg-red-100 text-red-800' },
]

// The flags turn off counts that would name a blocker the surrounding copy does not: pickable
// units where nothing will be picked, missing units where only the box is at fault.
export const PickabilityBreakdown = ({ pickability, showPickable = true, showMissing = true, className = '' }) => {
  const { i18n } = useTranslation()
  if (!pickability) return null
  const { pickable_units = 0, blocked_units = 0, missing_units = 0 } = pickability
  const parts = showPickable ? [`${i18n.t('pickability.breakdown.pickable')}: ${pickable_units}`] : []
  if (blocked_units > 0) parts.push(`${i18n.t('pickability.breakdown.blocked')}: ${blocked_units}`)
  if (showMissing && missing_units > 0) parts.push(`${i18n.t('pickability.breakdown.missing')}: ${missing_units}`)
  if (parts.length === 0) return null
  return <div className={`text-xs text-gray-500 mt-0.5 ${className}`}>{parts.join(' · ')}</div>
}

export const PickabilityBadge = ({ pickability, orderNumber, warehouseId }) => {
  const { i18n } = useTranslation()
  if (!pickability) return null
  const def = PICKABILITY_STATUSES.find(s => s.status === pickability.status)
  if (!def) return null
  // Breaking a container only unblocks units locked inside one; a partial caused solely by
  // missing stock has no box to break, so it gets no link.
  const showBreakLink = pickability.blocked_units > 0 && warehouseId != null && orderNumber
  return (
    <div>
      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ${def.classes}`}>
        {i18n.t(`pickability.status.${pickability.status}`)}
      </span>
      {showBreakLink && (
        <div className="mt-0.5">
          <Link
            to={`${PICKING_TASKS_TO_BREAK.replace(':warehouse_id', warehouseId)}?pivot=order&order_numbers=${encodeURIComponent(orderNumber)}`}
            className="text-xs text-indigo-600 hover:text-indigo-900 underline"
          >
            {i18n.t('pickability.go_to_break')}
          </Link>
        </div>
      )}
    </div>
  )
}
